import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '@/constants/routes';
import { ROLES } from '@/constants/users';
import { useAuth } from '@/hooks/useAuth';
import { parseSubdomain } from '@/utils/subdomainParser';

export const useNavigateToHome = () => {
  const navigate = useNavigate();
  const { role } = useAuth();

  const navigateToHome = useCallback(() => {
    const isShareDevice = parseSubdomain(window.location.hostname) !== null;

    // ユーザーロールベースで判定
    if (role === ROLES.STAFF) {
      // スタッフロール
      navigate(ROUTE_PATH.STAFF_ONLY);
    } else if (role === ROLES.SHARED_DEVICE && isShareDevice) {
      // 共有端末ロール
      navigate(ROUTE_PATH.SHARE_DEVICE);
    } else {
      // 一般ユーザーロール（または null）
      navigate(ROUTE_PATH.LOGIN);
    }
  }, [navigate, role]);

  return { navigateToHome };
};
